const phoneCodes = [
  { code: 1, mask: 'xxx xxx xxxx' },
  { code: 7, mask: 'xxx xxx xx xx' },
  { code: 8, mask: 'xxx xxx xx xx' },
  { code: 44, mask: 'xxxx xxxxxx' },
  { code: 61, mask: 'x xxxx xxxx' },
  { code: 49, mask: 'xxxx xxxxxxx' },
  { code: 33, mask: 'x xx xx xx xx' },
  { code: 91, mask: 'xxxxx xxxxx' },
  { code: 55, mask: 'xx xxxx xxxx' },
  { code: 39, mask: 'xxx xxxx xxxx' },
  { code: 34, mask: 'xxx xx xx xx' },
  { code: 27, mask: 'xx xxx xxxx' },
  { code: 52, mask: 'xx xx xxxx xxxx' },
]

export default {
  mounted(el) {
    let lastValue = ''

    function getCountryCode(numericValue) {
      // If there's no numeric value, return an empty string
      if (!numericValue) return ''

      // Find the longest matching country code
      let maxCodeLength = 0
      phoneCodes.forEach((code) => {
        const codeLength = code.code.toString().length
        if (
          numericValue.startsWith(code.code.toString()) &&
          codeLength > maxCodeLength
        ) {
          maxCodeLength = codeLength
        }
      })
      return numericValue.substr(0, maxCodeLength)
    }

    function formatPhoneNumber(value) {
      // Remove all non-digit characters
      const numericValue = value.replace(/\D/g, '')

      const countryCode = getCountryCode(numericValue)
      const restOfNumber = numericValue.substring(countryCode.length)
      const phoneCode = phoneCodes.find(
        (code) => code.code.toString() === countryCode
      )

      if (!phoneCode || !countryCode) return numericValue

      let formattedNumber = ''
      let maskIndex = 0

      for (
        let i = 0;
        i < restOfNumber.length && maskIndex < phoneCode.mask.length;
        i += 1
      ) {
        if (phoneCode.mask[maskIndex] === 'x') {
          formattedNumber += restOfNumber[i]
          maskIndex += 1
        } else {
          formattedNumber += phoneCode.mask[maskIndex]
          maskIndex += 1
          i -= 1 // Stay on the same digit
        }
      }

      return `${countryCode} ${formattedNumber}`
    }

    el.addEventListener('input', (e) => {
      const currentValue = e.target.value
      const formattedValue = formatPhoneNumber(currentValue)

      // Update the value if formatting changes it
      if (formattedValue !== lastValue) {
        const inputField = e.target
        inputField.value = formattedValue
      }

      lastValue = formattedValue
    })
  },
}
